// CRM 2.0 · M12 Template Builder · "Which applicant?" (DC-204): an applicant / POA field used outside the buyer
// block prints the 1st (default), 2nd, 3rd or 4th applicant, or all of them together. One pop-up style.
import React, { useState } from "react";
import cls from "./Templates.module.css";
import { APPLICANT_PICKS } from "./templateCommon";

function ApplicantPickModal({ blankNo, field, pick, onCancel, onSave }) {
  const [value, setValue] = useState(pick && pick !== "EACH" ? pick : "APPLICANT_1");
  return (
    <div className={cls.mask} role="dialog" aria-modal="true" aria-label="Which applicant?">
      <div className={cls.modal}>
        <div className={cls.modalHead}>
          <h2>Which applicant?</h2>
          <p className={cls.hint}>Blank {blankNo} · {field?.label}. This blank is outside the buyer block, so it prints one applicant, or all of them together.</p>
        </div>
        <div className={cls.modalBody}>
          {APPLICANT_PICKS.map(([k, label]) => (
            <label key={k} className={`${cls.radio} ${value === k ? cls.radioOn : ""}`}>
              <input type="radio" name="applicantPick" checked={value === k} onChange={() => setValue(k)} />
              <span><b>{label}</b>{k !== "APPLICANT_1" && k !== "ALL_TOGETHER" ? <><br /><span className={cls.hint}>Printed empty when the booking has fewer applicants</span></> : null}</span>
            </label>
          ))}
        </div>
        <div className={cls.modalFoot}>
          <button className={cls.btn} onClick={onCancel}>Cancel</button>
          <button className={`${cls.btn} ${cls.primary}`} onClick={() => onSave(value)}>Save</button>
        </div>
      </div>
    </div>
  );
}

export default ApplicantPickModal;
